module.exports = __webpack_public_path__ + "img/1448438275.49df5ca4.jpg";